var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAfrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 480,
    id: "south",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-71.873-.012h682.68v512.01h-682.68z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(67.379 .011) scale(.93748)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-71.878 407.837V104.428l225.832 151.627-225.832 151.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00c",
    d: "m82.217 512.121 253.538-170.644h360.372v170.644H82.217z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m65.917.062 630.19.013v170.672H335.735S69.295-1.626 65.917.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M-71.878 64.075v40.329L153.954 256.03-71.878 407.823v40.327l284.44-192.12-284.44-191.955z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#093",
    d: "M-71.878 64.075V.062h94.891l301.313 203.88h371.778v104.261H324.326L23.013 512.053h-94.89V448.15l284.439-192.12-284.44-191.955z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.013.062h59.194l253.538 170.673h360.372v33.207H324.339L23.025.062zm0 512.059h59.194l253.538-170.644h360.372v-33.206H324.339L23.025 512.12z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfrica);
export default __webpack_public_path__ + "static/media/africa.50a2a4dd18d1241e8b307b36fa5fc43b.svg";
export { ForwardRef as ReactComponent };